import React, { useRef, useState } from 'react';
import { Header } from './Header';

interface OnboardingProps {
  onComplete: () => void;
}

interface OnboardingStep {
  title: string;
  type: 'image' | 'video';
  imageUrl?: string;
  videoUrl?: string;
  bgColor?: string;
}

const onboardingSteps: OnboardingStep[] = [
  {
    title: "Catch Listings\nBefore The Crowd",
    type: 'image',
    imageUrl: "/onboarding/1.png",
    bgColor: "bg-primary"
  },
  {
    title: "Get In Before It Pumps",
    type: 'image',
    imageUrl: "/onboarding/2.gif",
    bgColor: "bg-black"
  },
  {
    title: "Take Profit When It Pumps.",
    type: 'image',
    imageUrl: "/onboarding/3.gif",
    bgColor: "bg-black"
  }
];

export const Onboarding: React.FC<OnboardingProps> = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const videosRefs = useRef<HTMLVideoElement | null[]>([]);

  const handleNext = () => {
    if (currentStep < onboardingSteps.length - 1) {
      videosRefs.current[currentStep + 1]?.play();
      setTimeout(() => {
        setCurrentStep(currentStep + 1);
      }, 50);
    } else {
      onComplete();
    }
  };

  const currentStepData = onboardingSteps[currentStep];
  const isLastStep = currentStep === onboardingSteps.length - 1;

  return (
    <div className="min-h-screen bg-primary text-text-primary flex flex-col">
      <Header backVisible={false} subtitle="Welcome" />
      <div className="flex-1 flex flex-col items-center p-3 justify-center">
        {/* Video Card */}
        <div className="flex-1 flex flex-col gap-6 justify-start w-full">
          <div className={`onboarding-gradient-border p-2 relative max-h-[calc(75vh-5rem)] flex-1 min-h-0 overflow-hidden items-center flex w-full rounded-xl ${currentStepData.bgColor}`}>
            {/* Video Placeholder */}
            {onboardingSteps.map(({ type, videoUrl, imageUrl }, index) => {
              return (
                <div key={index}>
                  {type === 'video' ? <video ref={(el) => videosRefs.current[index] = el} src={videoUrl} style={{ display: currentStep === index ? 'block' : 'none' }} preload="auto" muted className="w-full h-full object-cover" /> : <img src={imageUrl} alt="onboarding" className="w-full h-full object-cover" style={{ display: currentStep === index ? 'block' : 'none' }} />}
                </div>
              )
            })}
            {/* {currentStepData.type === 'video' ? (
              <video src={currentStepData.videoUrl} autoPlay preload="auto" muted className="w-full h-full object-cover" />
            ) : (
              <img src={currentStepData.imageUrl} alt={currentStepData.title} className="w-full h-full object-cover" />
            )} */}
            <div className="absolute bottom-6 z-10 left-[50%] translate-x-[-50%] w-full">
              <div className="flex items-center justify-center">
                <span className="text-text-primary text-2xl text-center font-semibold">
                  {currentStepData.title.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < currentStepData.title.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </span>
              </div>
            </div>
          </div>



          {/* Next Button */}
          <div className="absolute bottom-14 left-0 right-0 mx-3 flex flex-col gap-3 h-20">
            {/* Stepper */}
            <div className="flex items-center justify-center space-x-0 h-[3vh]">
              {onboardingSteps.map((_, index) => (
                <React.Fragment key={index}>
                  {/* Dot */}
                  <div
                    className={`w-[20px] h-[20px] rounded-full transition-colors border-accent-light border-2 ${index <= currentStep ? 'bg-accent-light' : ''
                      } flex items-center justify-center`}
                  >
                    <span className={`${index <= currentStep ? 'text-black' : 'text-accent-light'} text-sm text-center`}>
                      {index + 1}
                    </span>
                  </div>

                  {/* Line (except after last dot) */}
                  {index < onboardingSteps.length - 1 && (
                    <div
                      className={`w-[20px] h-0.5 transition-colors bg-accent-light
                        }`}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
            <button
              onClick={handleNext}
              className={`w-full py-3 ${isLastStep ? 'bg-accent' : 'bg-primary border-2 border-secondary'} text-text-primary font-semibold rounded-xl transition-colors`}
            >
              {isLastStep ? 'Get Started' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 